import React from 'react';
import cn from 'classnames';
import { TranslationOptions } from 'i18next';

import Locale from '../../Translate/Locale';

import styles from './Heading2.scss';

type Props = {
  className?: string;
  children: string;
  localeOptions?: TranslationOptions;
};

function Heading2(props: Props) {
  return (
    <h2 className={cn(props.className, styles.default)}>
      <Locale options={props.localeOptions}>{props.children}</Locale>
    </h2>
  );
}

export default Heading2;
